<template>
    <div v-if="!loading">
      <v-breadcrumbs
        large
        :items="crumbs"
        divider="/"
        class="pl-0"
      ></v-breadcrumbs>

      <h1 class="primary--text">
        <v-icon color="primary">mdi-note</v-icon> <span>Features disponíveis</span>
      </h1>
        <div style="position:relative">
        <v-container>
          <v-speed-dial
            absolute
            v-model="speedDial"
            top
            right
            direction="bottom"
            :open-on-hover="true"
          >
            <template v-slot:activator>
              <v-tooltip right color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs" v-on="on"
                    v-model="speedDial"
                    color="primary"
                    dark
                    x-large
                    fab
                  >
                    <v-icon v-if="speedDial">
                      mdi-close
                    </v-icon>
                    <v-icon v-else>
                      mdi-dots-vertical
                    </v-icon>
                  </v-btn>
                </template>
                <span>Opções</span>
              </v-tooltip>
            </template>
            <v-tooltip right color="info">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs" v-on="on"
                  fab
                  dark
                  small
                  color="info"
                  large
                  @click="searching = true"
                >
                  <v-icon>mdi-filter</v-icon>
                </v-btn>
              </template>
              <span>Pesquisar</span>
            </v-tooltip>
            <v-tooltip right color="secondary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs" v-on="on"
                  fab
                  dark
                  small
                  color="secondary"
                  large
                  to="/admin/settings/features/create"
                  v-if="$root.session.hasPermission(['super', 'features.write'])"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Registar</span>
            </v-tooltip>
          </v-speed-dial>
        </v-container>

        <v-data-table
          :headers="headers"
          :items="items"
          :server-items-length="total"
          :loading="loading"
          :footer-props="tableFooter"
          :options.sync="options"
          class="mt-16 elevation-10"
          locale="pt-pt"
        >

          <template v-slot:item.actions="{item}">
            <v-switch
                class="mt-n2"
                color="success"
                v-model="active_features"
                hide-details
                :value="item.id"
                @change="filterChange(item)"
              ></v-switch>
          </template>
        </v-data-table>
      </div>
      <v-navigation-drawer
          fixed
          right
          v-model="searching"
          hide-overlay
          width="520"
          class="pt-6"
        >
        <v-list>
          <v-list-item>
            <v-btn fab small color="secondary" @click="searching = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <v-btn absolute right small color="error" @click="resetFeatures">
              Limpar Campos
            </v-btn>
          </v-list-item>
        </v-list>
        <v-list class="pt-10">
          <v-form @submit.prevent="searchFeatures">
            
            <v-list-item>
              <v-text-field
                v-model="filter.name"
                prepend-inner-icon="mdi-account-details"
                label="Código"
                clearable
              ></v-text-field>
            </v-list-item>

            <v-list-item>
              <v-text-field
                v-model="filter.display_name"
                prepend-inner-icon="mdi-account-details"
                label="Nome"
                clearable
              ></v-text-field>
            </v-list-item>
            <v-row
              class="mt-10"
              align="center"
              justify="space-around"
            >
            <v-btn
              color="primary"
              type="submit"
            >
              Pesquisar
            </v-btn>
            </v-row>
          </v-form>
        </v-list>
      </v-navigation-drawer>
      <AddFeature ref="AddFeature" @reloadFeatures="searchFeatures"/>

    </div>
</template>
<script>
import Feature from "@/api/Feature.js";
import Tenant from "@/api/Tenant.js";
import AddFeature from '@/components/features/main/AddFeature.vue';

export default {
  props: ['tenant'],
  components: {
    AddFeature
  },
  watch: {
    'options': {
      immediate: false,
      handler () {
        setTimeout(() => {this.searchFeatures()}, 10);
      },
      deep: true,
    },
  },
  beforeCreate(){
    document.title = "Hefesto - Gestão de Features";

  },
  data: () => ({
    active_features: [],
    headers: [
      {
        text: 'Nome',
        sortable: false,
        value: 'name',
      },
      {
        text: 'Título',
        sortable: false,
        value: 'title',
      },
      {
        text: 'Descrição',
        sortable: false,
        value: 'description',
      },
      { 
        text: 'Opções', 
        value: 'actions', 
        sortable: false 
      },
    ],
    items: [],
    total: 0,
    loading: true,
    searching: false,
    tableFooter: {
      'items-per-page-options': [5, 10, 15, 20],
      'items-per-page-text': "Linhas por página"
    },
    options: {},
    speedDial:false,
    filter: {
      name: null,
      display_name:null,
      user_id:null,
    },
    users:[]
  }),
  mounted(){

    if(!this.$root.session.hasPermission(["super", "features.read"])) {
      this.$router.push('/admin');
    }


    this.fillBaseData();
  },
  methods:{
    filterChange(item){
        let params = {
            tenant_id: this.tenant,
            feature_id: item.id
        }
        let type = 'addFeature';
        if(!this.active_features.includes(item.id))
          type = 'removeFeature';
          
        Tenant[type](params).then(() => {

        });
    },
    async fillBaseData() {

      if(localStorage["features-" + this.$root.session.id] != undefined){

        let data = JSON.parse(localStorage["features-" + this.$root.session.id]);

        this.filter = data.filter;

        this.options = data.options;
      }

      await Feature.list({tenant: this.tenant}).then(response =>{
        let data = response.data

        data.forEach(element => {
          this.active_features.push(element.feature_id)
        });
      })
      this.loading = false

      console.log(this.active_features)
    },
    searchFeatures(event){
      if(!!event && event.type == 'submit'){
        this.options.page = 1;
      }


      let filter = {...this.filter};

      let request = {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        tenant: this.tenant
      };
    
      Object.assign(request, filter);

      localStorage["features-" + this.$root.session.id] = JSON.stringify({
        filter: this.filter,
        options: this.options,
      });

      Feature.search(request).then(response => {
        
        let data = response.data;

        this.total = data.total;

        this.items = data.data.map((item) => {

          this.searching = false;

          return item;
        });

      });
    },
    resetFeatures()
    {
      this.filter = {};

      this.searchFeatures();
    },
    viewFeature(item){
      this.$router.push('/admin/settings/features/' + item.id);
    },
    deleteFeature(item){
    Feature.delete(item.id)
        .then(() => {
          this.searchFeatures();
        });
    },
  },
  computed: {
    crumbs: function() {
      return [
        {
          text: 'Gestão Interna',
          disabled: false,
          to: '#',
          exact: true,
        },
        {
          text: 'Gestão de Features',
          disabled: true,
          to: window.location.href,
          exact: true,
        },
      ];
    }
  }
};
</script>
